"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2030],{

/***/ 82030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ heroBanner_RemoteHeroBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/SimpleGrid/index.js
var SimpleGrid = __webpack_require__(67440);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/heroBanner/columnBannersShared.tsx
var columnBannersShared = __webpack_require__(62001);
;// CONCATENATED MODULE: ./src/components/heroBanner/util.ts

var mapBannerFields = function(banner, onClickBannerCta) {
    return {
        content: {
            imageTreatment: mapImageTreatmentCodename(banner.imageTreatment),
            copyBlockAlignment: mapAlignmentCodename(banner.copyBlockAlignment),
            backgroundColor: banner.bgColour
        },
        title: {
            text: banner.title,
            textColor: banner.titleTextColour,
            highlightTextColor: banner.highlightTextColour,
            fontFamily: (0,columnBannersShared/* getFontFamily */.BN)(banner.titleFont),
            fontVariant: mapFontSizeCodename(banner.titleFontSize)
        },
        description: {
            text: banner.description,
            textColor: banner.descriptionTextColour,
            fontVariant: mapFontSizeCodename(banner.descriptionFontSize)
        },
        badge: getCmsItemCodename(banner.displayBadge) === "yes" ? {
            alignment: banner.badgeAlignment,
            text: banner.badgeText,
            textColor: banner.badgeTextColor,
            backgroundColor: banner.badgeBackgroundColor,
            outlineColor: banner.badgeOutlineColor
        } : undefined,
        images: [
            {
                desktop: banner.imageDesktop,
                tablet: banner.imageTablet,
                mobile: banner.imageMobile
            },
            banner.imageN2Desktop ? {
                desktop: getCmsItem(banner.imageN2Desktop),
                tablet: getCmsItem(banner.imageN2Tablet),
                mobile: getCmsItem(banner.imageN2Mobile)
            } : undefined, 
        ],
        buttons: banner.buttons.map(function(btn) {
            return {
                text: btn.cta_text,
                variant: mapButtonVariant(btn.cta_variant),
                action: function() {
                    return onClickBannerCta(btn);
                }
            };
        })
    };
};
var transformStoreHeroBannerData = function(banner, onClickBannerCta) {
    return {
        content: {
            imageTreatment: mapImageTreatmentCodename(getCmsItemCodename(banner.imageTreatment)),
            copyBlockAlignment: mapAlignmentCodename(getCmsItemCodename(banner.copyBlockAlignment)),
            backgroundColor: banner.backgroundColour
        },
        title: {
            text: banner.title,
            textColor: banner.titleTextColour,
            highlightTextColor: banner.highlightTextColour,
            fontFamily: (0,columnBannersShared/* getFontFamily */.BN)(getCmsItemCodename(banner.titleFontStyle)),
            fontVariant: mapFontSizeCodename(getCmsItemCodename(banner.titleFontSize))
        },
        description: {
            text: banner.description,
            textColor: banner.descriptionTextColour,
            fontVariant: mapFontSizeCodename(getCmsItemCodename(banner.descriptionFontSize))
        },
        badge: getCmsItemCodename(banner.displayBadge) === "yes" ? {
            alignment: getCmsItemCodename(banner.badgeAlignment),
            text: banner.badgeText,
            textColor: banner.badgeTextColour,
            backgroundColor: banner.badgeBackgroundColour,
            outlineColor: banner.badgeOutlineColour
        } : undefined,
        images: [
            {
                desktop: banner.imageDesktop,
                tablet: banner.imageTablet.items[0],
                mobile: banner.imageMobile.items[0]
            },
            banner.image2Desktop ? {
                desktop: banner.image2Desktop.items[0],
                tablet: banner.image2Tablet.items[0],
                mobile: banner.image2Mobile.items[0]
            } : undefined, 
        ],
        buttons: banner.buttons.items.map(function(btn) {
            return {
                text: btn.ctaText,
                variant: mapButtonVariant(getCmsItemCodename(btn._ctaStyle.style)),
                action: function() {
                    return onClickBannerCta(btn);
                }
            };
        })
    };
};
var transformHeroBannerBlockData = function(heroBanner, onClickBannerCta) {
    if ("leftGroup" in heroBanner && "rightGroup" in heroBanner) {
        var leftGroup = heroBanner.leftGroup, rightGroup = heroBanner.rightGroup;
        return [
            leftGroup,
            rightGroup
        ].map(function(banner) {
            return mapBannerFields(banner, onClickBannerCta);
        });
    } else {
        return mapBannerFields(heroBanner, onClickBannerCta);
    }
};
var getCmsItem = function(data) {
    if ("items" in data) return data.items[0];
    return data;
};
var getCmsItemCodename = function(data) {
    if (typeof data === "string") return data;
    return data === null || data === void 0 ? void 0 : data.items[0]._system_.codename;
};
var mapFontSizeCodename = function(codename) {
    switch(codename){
        case "xxl":
            {
                return "display1";
            }
        case "xl":
            {
                return "display2";
            }
        case "l":
            {
                return "h1";
            }
        case "m":
            {
                return "h2";
            }
        case "large":
            {
                return "body1";
            }
        case "regular":
            {
                return "body2";
            }
    }
    return codename;
};
var mapAlignmentCodename = function(codename) {
    switch(codename){
        case "centre":
            {
                return "center";
            }
    }
    return codename;
};
var mapImageTreatmentCodename = function(codename) {
    switch(codename){
        case "edge_to_edge":
            {
                return "edge-to-edge";
            }
    }
    return codename;
};
var mapButtonVariant = function(buttonVariant) {
    switch(buttonVariant){
        case "white_regular":
        case "white_small":
            {
                return "primaryInverted";
            }
        case "white_regular_ghost":
        case "white_small_ghost":
            {
                return "secondaryInverted";
            }
        case "primary_regular_ghost":
        case "primary_small_ghost":
        case "primary_small":
        case "primary_regular":
            {
                return "primary";
            }
        case "video_play":
        case "secondary_regular_ghost":
        case "secondary_small_ghost":
        case "secondary_small":
        case "secondary_regular":
            {
                return "secondary";
            }
        case "tertiary_regular_ghost":
        case "tertiary_small_ghost":
        case "tertiary_small":
        case "tertiary_regular":
            {
                return "tertiary";
            }
    }
    return "primary";
};

;// CONCATENATED MODULE: ./src/components/heroBanner/RemoteHeroBanner.tsx







var HeroBannerContainer = dynamic_default()(function() {
    return(// @ts-ignore
    __webpack_require__.e(/* import() */ 9963).then(__webpack_require__.t.bind(__webpack_require__, 89963, 23)).then(function(m) {
        return m.HeroBannerContainer;
    }, {
        ssr: false
    }));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89963)
            ];
        }
    }
});
var SecondaryBanner = dynamic_default()(function() {
    return(// @ts-ignore
    __webpack_require__.e(/* import() */ 9963).then(__webpack_require__.t.bind(__webpack_require__, 89963, 23)).then(function(m) {
        return m.SecondaryBanner;
    }));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89963)
            ];
        }
    },
    ssr: false
});
// @ts-ignore
var HeroBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9963).then(__webpack_require__.t.bind(__webpack_require__, 89963, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89963)
            ];
        }
    },
    ssr: false
});
var RemoteHeroBanner = function(param) {
    var data = param.data, onClickBannerCta = param.onClickBannerCta, marginTop = param.marginTop, paddingX = param.paddingX, _carouselIndex = param.carouselIndex, carouselIndex = _carouselIndex === void 0 ? 0 : _carouselIndex;
    var ref = (0,react.useMemo)(function() {
        // This banner query response has already been transformed by the Rescript decoder so its
        // shape differs from the store banner.
        if (data.n1ColumnBanners.length) {
            return {
                fullWidth: data.width === "full_width",
                applyRadius: data.isBorderRadius,
                primaryBanner: transformHeroBannerBlockData(data.n1ColumnBanners[carouselIndex], onClickBannerCta),
                secondaryBanner: null
            };
        }
        if (data.n2ColumnBanner) {
            //@ts-ignore
            var ref = (0,_sliced_to_array/* default */.Z)(transformHeroBannerBlockData(data.n2ColumnBanner, onClickBannerCta), 2), primaryBanner = ref[0], secondaryBanner = ref[1];
            return {
                fullWidth: data.width === "full_width",
                applyRadius: data.isBorderRadius,
                primaryBanner: primaryBanner,
                secondaryBanner: secondaryBanner
            };
        }
        // This is the unformatted Store banner query response so we must use a different transform
        // function to render the store page banner
        if (data.n1ColumnBanners.items.length) {
            var ref1;
            return {
                isStorePage: true,
                fullWidth: getCmsItemCodename(data.width) === "full_width",
                applyRadius: getCmsItemCodename(data.applyRadius) === "yes",
                primaryBanner: transformStoreHeroBannerData((ref1 = data.n1ColumnBanners.items) === null || ref1 === void 0 ? void 0 : ref1[carouselIndex], onClickBannerCta),
                secondaryBanner: null
            };
        }
        return {};
    }, [
        data,
        onClickBannerCta,
        carouselIndex
    ]), isStorePage = ref.isStorePage, fullWidth = ref.fullWidth, applyRadius = ref.applyRadius, primaryBanner = ref.primaryBanner, secondaryBanner = ref.secondaryBanner;
    if (!primaryBanner) return null;
    return(// @ts-ignore
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HeroBannerContainer, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(SimpleGrid/* default */.Z, {
            columns: !!secondaryBanner ? {
                base: 1,
                xl: 3
            } : 1,
            width: fullWidth ? "full" : "auto",
            maxWidth: fullWidth ? "full" : "1440px",
            paddingX: paddingX,
            spacing: "10px",
            marginX: "auto",
            marginTop: marginTop,
            children: [
                // @ts-ignore
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HeroBanner, (0,_object_spread/* default */.Z)({
                    gridColumn: {
                        base: "1 / -1",
                        xl: "span 2"
                    },
                    rounded: applyRadius,
                    fullWidth: fullWidth,
                    isStorePage: isStorePage
                }, primaryBanner)),
                !!secondaryBanner && // @ts-ignore
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SecondaryBanner, (0,_object_spread/* default */.Z)({
                    gridColumn: {
                        base: "1 / -1",
                        xl: "span 1"
                    },
                    rounded: applyRadius,
                    fullWidth: fullWidth
                }, secondaryBanner))
            ]
        })
    }));
};
/* harmony default export */ var heroBanner_RemoteHeroBanner = (RemoteHeroBanner);


/***/ }),

/***/ 67440:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var layout_1 = __webpack_require__(33559);
exports.Z = layout_1.SimpleGrid;


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 39474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 53128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 10253:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91566);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);